import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SpinButton } from '@fluentui/react';

import { mergeStyleSets } from '@fluentui/react';
import SpanWithTooltip from 'src/components/base/SpanWithTooltip'


const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  }
});


export const NumericField = ({ value, onChange, min = 0, max = 100, pad = 0, ...props }) => {
  function ensureValue(newValue, alternativeValue) {
    const converted = +newValue;
    return !isNaN(converted) && converted >= min && converted <= max 
      ? converted
      : alternativeValue;
  }

  const ensuredValue = ensureValue(value, min);
  const [val, setValue] = useState(ensuredValue);
  
  useEffect(() => { setValue(ensuredValue) }, [ensuredValue]);

  function formatValue(val) {
    return val.toString().padStart(pad, '0');
  }

  function handleValueChange(newValue) {
    newValue = ensureValue(newValue, val);
    setValue(newValue), onChange(newValue);
    return formatValue(newValue);
  }

  return (
    <SpinButton value={formatValue(val)}
      onIncrement={value => handleValueChange(+value + 1)}
      onDecrement={value => handleValueChange(+value - 1)}
      onValidate={handleValueChange}
      {...props}
    />
  )
}

NumericField.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}


export function NumericFieldWithTooltip({ label, tooltip, ...props }) {
  return (
    <div className={classNames.root}>
      { label && <SpanWithTooltip label={label} tooltip={tooltip} />}
      <NumericField {...props} styles={{ root: { flex: '0' }, spinButtonWrapper: { width: '70px' }}} />
    </div>
  );
}


export default NumericField;